<template>
  <div class="order-view right_auth">
    <div class="top_dd">
      <div class="top">
        <div class="cell cell3 left">
          <span>订单时间：</span>
          <div class="right">
            <el-date-picker
              style="width: 270px"
              type="daterange"
              v-model="dateValue"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>

          <!-- <sd-select
            :open="open"
            @changeOpen="open = !open"
            :options="options.dateList"
            @changeOption="selectDateRange"
            :value="dateRange"
          >
          </sd-select> -->
          <!--<div class="select2_g right">-->
          <!--<input type="text" :value="dateRange.label" readonly="readonly" :class="open?'on':''" @click="open=!open">-->
          <!--<ul v-if="open">-->
          <!--<li v-for="date in options.dateList" :class="{'on':dateRange == date.id}" @click="selectDateRange(date)">{{date.label}}</li>-->
          <!--</ul>-->
          <!--</div>-->
        </div>
        <div class="cell cell2 left">
          <span>金额范围：</span>
          <div class="range right">
            <div class="empty">
              <p @click="clearPrice()">清空</p>
              <button @click="doSearch()">确定</button>
            </div>
            <input type="text" v-model="searchOrder.appointPriceBegin" />
            <span>-</span>
            <input type="text" v-model="searchOrder.appointPriceEnd" />
          </div>
        </div>
        <div class="cell cell1 right">
          <!--<span>老师编号：</span>-->
          <select v-model="searchOrder.numberType">
            <option value="4">老师编号</option>
            <option value="2">订单编号</option>
          </select>
          <input class="right" type="text" v-model="searchOrder.numberStr" />
        </div>
      </div>
      <div class="bottom">
        <ul>
          <li>
            <button class="btn_g alert" @click="doSearch()">搜索</button>
          </li>
          <li>
            <button class="btn_g primary" @click="clear()">重置</button>
          </li>
        </ul>
      </div>
    </div>
    <ul class="order_classify">
      <li
        v-for="(item, idx) in options.customerOrderType"
        :key="idx"
        :class="item.id == searchOrder.customerOrderType ? 'on' : ''"
        @click="changeStatus(item.id)"
      >
        {{ item.label }}
      </li>
      <li class="help" @click="help">下单帮助</li>
    </ul>
    <div class="bottom_dd">
      <div class="function">
        <ul class="left">
          <li>
            <button class="btn_g active" @click="creatOrder()">新建订单</button>
          </li>
          <!-- <li v-if="orderData.length"><button class="btn_g primary" @click="batchInvoice()">开具发票</button></li> -->
          <li v-if="orderData.length">
            <button class="btn_g primary" @click="batchPay()">批量支付</button>
          </li>
        </ul>
        <ul class="right" v-if="orderData.length">
          <li>
            <button class="btn_g primary" :disabled="this.pageInfo.pageNo <= 1" @click="prePage()">上一页</button>
          </li>
          <li style="margin-right: 0">
            <button
              class="btn_g primary"
              :disabled="this.pageInfo.pageNo >= this.pageInfo.totalPage"
              @click="nextPage()"
            >
              下一页
            </button>
          </li>
        </ul>
      </div>
      <div v-if="orderData.length">
        <div class="title_dd">
          <ul>
            <li><input type="checkbox" v-model="isSelectedAll" @click="selectAll" />稿件名称</li>
            <!-- <li>紧急</li> -->
            <li>选定老师</li>
            <li>定价</li>
            <li>实际付款</li>
            <li>订单状态</li>
            <li>操作</li>
          </ul>
        </div>
        <!-- 订单cell -->
        <table v-for="(item, idx) in orderData" :key="idx" class="order_tb">
          <colgroup>
            <col class="name_col" />
            <!-- <col class="priority_col" /> -->
            <col class="teacher_col" />
            <col class="pricing_col" />
            <col class="pay_col" />
            <col class="state_col" />
            <col class="operate_col" />
          </colgroup>
          <tbody>
            <tr class="tr-th">
              <td colspan="8">
                <!-- <input type="checkbox"> -->
                <input type="checkbox" :value="item" v-model="selected" />
                <!--<span class="number">-->
                <!--订单编号：<a target="_blank">{{item.orderNum}}</a>-->
                <!--</span>-->
                <span class="dealtime">{{ item.createTime }}</span>
                <div class="invoiced" v-if="item.invoiceId"></div>
              </td>
            </tr>
            <tr>
              <!-- 稿件 -->
              <td>
                <a
                  :class="canDownContribution(item) ? 'down-load' : ''"
                  @mouseenter.once="downContribution(item)"
                  class="blue"
                  :href="item.realPath || 'javascript:;'"
                  target="_blank"
                  :disabled="!item.realPath"
                  >{{ item.contributionName }}
                </a>
              </td>
              <!-- <td>{{ _options.pressingStatus[item.pressingStatus] }}</td> -->
              <td>{{ item.dubboNum }}</td>
              <td class="red">{{ item.appointPrice }}</td>
              <td class="red">{{ item.realityPrice }}</td>
              <td>
                <i class="demand on" v-jq-tips="'已需求'"></i>
                <i
                  class="demo"
                  :class="{ on: item.auditionIds }"
                  v-jq-tips="item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'"
                ></i>
                <i
                  class="pay"
                  :class="{ on: item.payId }"
                  v-jq-tips="item.payId ? '已经支付订单费用' : '订单尚未支付'"
                ></i>
                <i
                  class="finished"
                  :class="{ on: item.productId || item.voiceLength }"
                  v-jq-tips="item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'"
                ></i>
                <i class="canceled" v-if="item.orderStatus == 10" v-jq-tips="'已取消'"></i>
              </td>
              <td class="operate" style="border-right: 1px solid #e2e2e2">
                <button class="paybtn" v-if="canPay(item)" @click="singlePay(item)">立即支付</button>
                <a v-if="canAudition(item)" @click="voiceList(item.auditionIds)">查看试音</a>
                <router-link
                  :to="{ name: 'Discuss', query: { id: item.orderNum } }"
                  class="discuss"
                  v-if="item.payId"
                  >{{ item.dubbingGrade ? '查看评论' : '评价订单' }}</router-link
                >
                <!-- <a v-if="canDownContribution(item)" @click="downContribution(item)">下载稿件</a> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="summation" v-if="summation.show">
          <p>
            合计实付金额： <span>{{ summation.num }}</span
            >元
          </p>
        </div>
        <ul class="btn_ul">
          <li>
            <button class="btn_g ghost" @click="getStatistics()">查看合计</button>
          </li>
          <li>
            <button class="btn_g ghost" @click="getExcel()">导出本页表格</button>
          </li>
          <li>
            <button class="btn_g ghost" @click="getAllExcel">导出所有表格</button>
          </li>
        </ul>
        <div class="page_wrap">
          <sd-pager ref="pager" :page-data="pageInfo" @page-change="pageChange"></sd-pager>
        </div>
      </div>
      <div class="g_empty" v-if="!orderData.length">
        <p class="info">没有检测到相关的订单~</p>
      </div>
    </div>
    <sd-modal v-show="viewVoice">
      <div class="demo_voice">
        <div class="title">
          您的试音
          <i class="close" @click="viewVoice = false"></i>
        </div>
        <div class="content">
          <ul>
            <li v-for="(vo, index) in voiceLists" :key="index" :sound-id="vo.id">
              <a class="number" href="javascript:;">{{ index + 1 }}</a>
              <a class="dubber" href="javascript:;">{{ vo.auditionDubboNum + '号' }}</a>
              <a class="voice" href="javascript:;" :title="vo.auditionName">{{ vo.auditionName }}</a>
              <i class="play sound-play"></i>
            </li>
          </ul>
        </div>
      </div>
    </sd-modal>
    <div class="viki_modal">
      <sd-modal v-show="forHelp">
        <div class="viki">
          <div class="bg">
            <transition name="fade">
              <div class="first" v-if="orderViki.first">
                <div
                  class="btn"
                  @click="
                    orderViki.first = false;
                    orderViki.second = true;
                  "
                ></div>
              </div>
            </transition>
            <transition name="fade">
              <div class="second" v-if="orderViki.second">
                <div
                  class="btn"
                  @click="
                    orderViki.second = false;
                    orderViki.third = true;
                  "
                ></div>
              </div>
            </transition>
            <transition name="fade">
              <div class="third" v-if="orderViki.third">
                <div
                  class="btn"
                  @click="
                    orderViki.third = false;
                    forHelp = false;
                  "
                ></div>
              </div>
            </transition>
          </div>
        </div>
      </sd-modal>
    </div>
    <!-- <sd-confirm show="" type="select" title="title" content="content"></sd-confirm> -->
  </div>
</template>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
}
</style>
<script type="es6">
import {mapState, mapActions, mapGetters} from 'vuex'
import sdPager from '../components/sdPager'
import sdConfirm from '../components/sdConfirm'
import {util} from '../service/util'
import {service} from '../service/service'
import sdSelect from '../components/sdSelect.vue'
import sdModal from '../components/sdModal.vue'

let API = util.api([
    'FINDMYORDER', // 查询订单
    'SINGLECREATEORDER',// 创建普通订单
    'IMPROPERCREATEORDER', // 特殊订单
    'FINDMYAUDITION', // 查询试音
    'GETCONTRIBUTIONBYID',//id查询稿件
    'GETSTATISTICSBYCUSTOMERSEARCH',//合计
    'WAITERADDINVOICEAPPLY', // 客户根据订单开票
    'GETSTATISTICSBYCUSTOMERSEARCH', // 查看合计
    'DOWNLOADORDERINFO'
])
export default {
    name: 'order-view',
    components: {sdPager, sdConfirm, sdSelect, sdModal},
    data () {
        return {
            forHelp: false,
            orderViki: {
                first: false,
                second: false,
                third: false
            },
            viewVoice: false,
            //试音列表
            voiceLists: [],
            //选择框展开
            open: false,
            // 订单数据
            orderData: [],
            // 搜索条件参数
            searchOrder: {
                // 订单状态
                customerOrderType: '',
                numberType: 4
            },
            // 分页参数
            page: {
                pageNo: 1,
                pageSize: 1
            },
            // 当前分页信息
            pageInfo: {
                pageNo: 1,
                pageSize: 20,
                totalPage: 1,
                totalRecord: 1
            },
            options: {
                orderStatus: {
                    '1': '需求中',
                    '2': '试音中',
                    '3': '待支付',
                    '4': '录制中',
                    '5': '已成品',
                    '6': '已成品',
                    '8': '已成品',
                    '10': '已取消',
                },
                customerOrderType: [
                    {id: '', label: '全部订单'},
                    {id: '1', label: '需求中'},
                    {id: '2', label: '试音中'},
                    {id: '3', label: '待支付'},
                    {id: '4', label: '录制中'},
                    {id: '5', label: '已成品'},
                    // { id:'10',label:'已取消'}
                ],

            },
            // 已经勾选的订单
            selected: [],
            isSelectedAll: false,
            // 日期选项

            dateValue: [],
            pickerOptions: {
              shortcuts: [{
                text: '近三个月订单',
                onClick(picker) {
                  const end =  moment().format('YYYY-MM-DD 23:59:59') ;
                  const start = moment().add(-3, 'M').format('YYYY-MM-DD 00:00:00');
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '近六个月订单',
                onClick(picker) {
                  const end = moment().format('YYYY-MM-DD 23:59:59');
                  const start = moment().add(-6, 'M').format('YYYY-MM-DD 00:00:00');
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '一年前的订单',
                onClick(picker) {
                  const end = moment().add(-1, 'Y').format('YYYY-MM-DD 00:00:00') ;
                  const start = moment().add(-5, 'Y').format('YYYY-MM-DD 00:00:00');
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            //合计
            summation: {
                show: false,
                num: 0
            }
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.common.userInfo,
            _options: state => state.common.options
        }),
    },
    methods: {
        //下单帮助
        help(){
            this.forHelp = true;
            this.orderViki.first = true;
        },
        //查看试音
        voiceList(_ids){
            let ids = _ids.split(',');
            util.kAjax(API.FINDMYAUDITION, {ids: ids}, res => {
                this.viewVoice = true;
                util.addSoundData(res.data);
                this.voiceLists = res.data;
            })
        },
        // 可支付
        canPay(item) {
            return item.orderStatus == 3 || (item.orderStatus > 3 && item.orderStatus != 10 && !item.payId );
        },
        // 可查询试音
        canAudition(item) {
            return item.auditionIds;
        },
        // 可下载稿件
        canDownContribution(item) {
            return item.contributionId;
        },

      // 下载稿件
      downContribution(r) {
        if (!r.contributionId) {
          return;
        }
        util.kAjax(API.GETCONTRIBUTIONBYID, {id: r.contributionId}, function (json) {
          // r.realPath = 'http://d.sd235.net/' + json.data.contributionServerPath;
          r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath;
         // window.open('http://d.sd235.net/' + json.data.contributionServerPath);
        }, function (err) {
          // util.confirm.error('错误','未找到该稿件！');
        },true)
      },
        // 显示的订单状态
        statusLabel(order) {
            let status = order.orderStatus,
                payId = order.payId;
            if (status >= 3 && status != 10 && !payId) {
                return '待支付';
            }
            return this._options.orderStatus[status];
        },
        /**
         * 点击改变订单状态
         */
        changeStatus(id) {
          console.log(id);
            this.searchOrder.customerOrderType = id;
            // 清空页数
            this.pageInfo.pageNo = 1;
            this.doSearch();
        },
        /**
         * 分页更改
         */
        pageChange() {
            this.doSearch();
        },
        /**
         * 选择时间范围
         */
        selectDateRange(date) {
            this.dateRange = date;
            this.open = !this.open;
            this.doSearch();
        },
        /**
         * 清空搜索
         */
        clear() {
            this.searchOrder.appointPriceBegin = '';
            this.searchOrder.appointPriceEnd = '';
            this.searchOrder.numberStr = '';
            this.pageInfo.pageNo = 1;
            this.dateRange = this.options.dateList[0];
            this.doSearch();
        },
        /**
         * 选择全部
         */
        selectAll() {
            if (!this.isSelectedAll) {
                this.selected = [];
                this.orderData.forEach(d => {
                    this.selected.push(d);
                })
            } else {
                this.selected = [];
            }
        },
        /**
         * 取消全部选中
         */
        unSelectAll() {
            this.selected = [];
        },
        /**
         * 清空价格
         */
        clearPrice() {
            this.searchOrder.appointPriceBegin = '';
            this.searchOrder.appointPriceEnd = '';
            this.doSearch();
        },

        // 上一页
        prePage() {
            this.$refs.pager.prePage();
        },
        // 下一页
        nextPage() {
            this.$refs.pager.nextPage();
        },
        // 执行搜索
        doSearch() {
            // 取消显示合计
            this.summation.show = false;
            let param = {
                searchOrder: {
                    ...this.searchOrder,
                    beginDate: this.dateValue[0],
                    endDate: this.dateValue[1]
                },
                page: {
                    pageNo: this.pageInfo.pageNo,
                    pageSize: this.pageInfo.pageSize
                }
            }
            util.kAjax(API.FINDMYORDER, param, res => {
                res.data.datas.map(d => d.realPath = '');
                this.orderData = res.data.datas;
                this.pageInfo.pageNo = res.data.pageNo;
                this.pageInfo.totalPage = res.data.totalPage;
                this.pageInfo.totalRecord = res.data.totalRecord;
                this.unSelectAll();
            })
        },
        /**
         * 单个支付
         */
        singlePay(item) {
            let orders = [item];
            this.$store.commit('PAYORDERS', orders);
            this.$router.push({
                name: 'PayView'
            })
        },
        /**
         * 批量支付
         */
        batchPay() {
            // 1. 已定价 2. 未支付 3. 未终止
            let orders = [];

            for (let i in this.selected) {
                let d = this.selected[i];
                if (!this.canPay(d)) {
                    util.confirm.error('请选择已定价而未支付的订单！');
                    return;
                }
                orders.push(d);
            }
            if (!this.selected.length) {
                util.confirm.error('无可支付的订单！');
                return;
            }

            this.$store.commit('PAYORDERS', this.selected);
            this.$router.push({
                name: 'PayView',
            })
        },
        /**
         * 批量开票
         * 1.已经支付，2.未开票，3.总金额大于300
         */
        batchInvoice() {
            let orders = [],
                money = 0;
            for (let i in this.selected) {
                let d = this.selected[i];
                if (!d.payId || d.orderStatus <= 3 || d.orderStatus == 10 || (!d.voiceLength && !d.productId)) {
                    util.confirm.error('请选择已支付且已录成品而未开票的订单！');
                    return;
                }
                if (d.invoiceId) {
                    util.confirm.error('请选择未开票的订单！');
                    return;
                }
                money += d.realityPrice;
                orders.push(d);
            }
            if (!orders.length) {
                util.confirm.error('请选择订单！');
                return;
            }
            // 校验
            if (money < 300) {
                util.confirm.error('开票总价需大于300元！');
                return;
            }
            this.$store.commit('INVOICEORDERS', orders);
            this.$router.push({
                name: 'InvoiceView'
            })
        },
        // 查看合计
        getStatistics() {
            let param = {
                searchOrder: {
                    ...this.searchOrder,
                    beginDate: this.dateValue[0],
                    endDate: this.dateValue[1]
                }
            }
            util.kAjax(API.GETSTATISTICSBYCUSTOMERSEARCH, param, res => {
                if (!res.data) {
                    this.summation.show = true;
                    this.summation.num = 0;
                } else {
                  this.summation.show = true;
                  console.log('this.searchOrder.customerOrderType', this.searchOrder.customerOrderType );
                  if (this.searchOrder.customerOrderType == 3) {
                    // 22.04.14 this.searchOrder.customerOrderType === 3 表示选中的标签页是待支付
                    // 待支付的合计显示字段变更
                    this.summation.num = res.data.appointPrice || 0;
                    return;
                  }
                  this.summation.num = res.data.realityPrice || 0;
                }
            })
        },
        // 导出本页表格
        getExcel() {
            var data = util.copy(this.orderData),
                src = [],
                title = ['稿件名称', '紧急', '选定老师', '定价', '实际付款', '订单状态', '创建时间'];

            if (!data.length) {
                util.confirm.error('无订单数据！');
                return;
            }

            data.forEach((d, i) => {
                src.push([

                    d.contributionName,
                    this._options.pressingStatus[d.pressingStatus],
                    d.dubboNum,
                    d.appointPrice,
                    d.realityPrice,
                    this.options.orderStatus[d.orderStatus],
                    moment(d.createTime).format('MM-DD HH:mm'),
                ])
            })
            util.toCSV(src, title, '订单信息' + moment().format('MM-DD HH:mm') + '.csv');
        },
        //导出所有表格
        getAllExcel(){
            let param = {
                ...this.searchOrder,
                beginDate: this.dateValue[0],
                endDate: this.dateValue[1],
            };
            let str = '';
            for(let i in param){
                if(param[i]){
                    str += `${i}=${param[i]}&`;
                }
            }
            str = str.substring(0,str.length-1);
            window.open(`${API.DOWNLOADORDERINFO}?${str}`);
        },
        // 创建订单
        creatOrder() {
            service.creatOrder(this.doSearch);
        }
    },
    watch: {
        selected(value) {
            if (!this.selected.length) {
                this.isSelectedAll = false;
                return;
            }
            this.isSelectedAll = (value.length == this.orderData.length);
        },
    },
    created() {
        this.doSearch();
    },
  mounted(){
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// OrderView.vue?0d7f1a4c